import CryptoJS from 'crypto-js';
import { ApiService } from 'src/app/services/api.service';

import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-scan-sell-ticket',
  templateUrl: './scan-sell-ticket.page.html',
  styleUrls: ['./scan-sell-ticket.page.scss'],
})
export class ScanSellTicketPage implements OnInit {
  @Input() realtrip;
  qr: string;
  availability: number;
  private secureKey = '17749937251153819552391078335260'; // Any string, the length should be 32
  qrInterval;

  constructor(private modalCtrl: ModalController, private api: ApiService) {}

  ngOnInit() {
    this.setQr();
    this.checkAvailability();
    this.qrInterval = setInterval(() => {
      this.setQr();
      this.checkAvailability();
    }, 10000);
  }

  ionViewWillLeave() {
    clearInterval(this.qrInterval);
  }

  setQr() {
    const n = new Date().toISOString();
    this.qr = CryptoJS.AES.encrypt(
      `ticketsell|${this.realtrip.id}|${this.realtrip.current_stop_id}|${n}|`,
      this.secureKey
    ).toString();
  }

  checkAvailability() {
    this.api.getData('transportec_realtrip/availability?realtrip_id=' + this.realtrip.id).then((response) => {
      this.availability = +response.availability;
    });
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
